const getFileExtension = (filename: string) => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) return ""; // No extension found
  return filename.substring(lastDotIndex + 1);
};

export default getFileExtension;